import React from "react";
import { useLocation } from "react-router-dom";

const withQueryParams = <P extends object>(
  keys: string[],
  Component: React.ComponentType<P>
) => {
  return (props: Omit<P, "queryParams">) => {
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const extractedParams: { [key: string]: string | null } = {};

    keys.forEach((key) => {
      extractedParams[key] = queryParams.get(key);
    });
    //@ts-ignore
    return <Component {...(props as P)} {...extractedParams} />;
  };
};

export default withQueryParams;
